<template>
    <div class="mid_scroll_content portfolioPage">
        <loader v-show="pageLoader"></loader>
        <section class="border-0">
            <div class="ml-0" :class="settingTab != 'Crypto'  && settingTab != 'Activity' && settingTab != 'Limits' ? '' : ''">
                <div class="settingPage d-flex align-items-start">
                    <div class="customMax">
                        <ul class="settingTabs border">
                            <li>
                                <a @click.prevent="settingTab = 'Account'"
                                    :class="settingTab == 'Account' ? 'active' : ''"
                                    href="javascript:void(0)">Account</a>
                            </li>
                            <li v-if="get_user.lead_type == 1">
                                <a @click.prevent="settingTab = 'organization'"
                                    :class="settingTab == 'organization' ? 'active' : ''"
                                    href="javascript:void(0)">Organization Info</a>
                            </li>
                            <li v-if="get_user.lead_type == 1">
                                <a @click.prevent="settingTab = 'addressinfo'"
                                    :class="settingTab == 'addressinfo' ? 'active' : ''"
                                    href="javascript:void(0)">Address Info</a>
                            </li>
                            <li v-if="permissionModule('FIAT')">
                                <a @click.prevent="settingTab = 'bankinfo'"
                                    :class="settingTab == 'bankinfo' ? 'active' : ''"
                                    href="javascript:void(0)">Bank Info</a>
                            </li>
                            <li>
                                <a @click.prevent="settingTab = 'documents'"
                                    :class="settingTab == 'documents' ? 'active' : ''"
                                    href="javascript:void(0)">Documents</a>
                            </li>
                            <li>
                                <a @click.prevent="settingTab = 'Notifications'"
                                    :class="settingTab == 'Notifications' ? 'active' : ''"
                                    href="javascript:void(0)">Notifications</a>
                            </li>
                            <li>
                                <a @click.prevent="settingTab = 'Security'"
                                    :class="settingTab == 'Security' ? 'active' : ''"
                                    href="javascript:void(0)">Security</a>
                            </li>
                            <li>
                                <a @click.prevent="settingTab = 'Activity'"
                                    :class="settingTab == 'Activity' ? 'active' : ''"
                                    href="javascript:void(0)">Activity</a>
                            </li>
                            <!-- <li> <a @click.prevent="settingTab='Confirmed'" :class="settingTab=='Confirmed' ? 'active' : ''" href="javascript:void(0)" >Confirmed Devices</a > </li><li> <a @click.prevent="settingTab='Privacy'" :class="settingTab=='Privacy' ? 'active' : ''" href="javascript:void(0)" >Privacy</a > </li>-->
                            <li >
                                <a @click.prevent="settingTab = 'API'" :class="settingTab == 'API' ? 'active' : ''" href="javascript:void(0)">API</a>
                            </li>
                            <li v-if="get_user.lead_type == 0">
                                <a @click.prevent="settingTab = 'Limits'"
                                    :class="settingTab == 'Limits' ? 'active' : ''" href="javascript:void(0)">Account
                                    Limits</a>
                            </li>
                            <li>
                                <a @click.prevent="settingTab = 'Crypto'"
                                    :class="settingTab == 'Crypto' ? 'active' : ''" href="javascript:void(0)">Crypto
                                    Addresses</a>
                            </li>
                        </ul>
                    </div>
                    <div class="calcWidth">
                        <app-account v-if="settingTab == 'Account'"></app-account>
                        <app-organization v-if="settingTab == 'organization'"></app-organization>
                        <app-addressinfo v-if="settingTab == 'addressinfo'"></app-addressinfo>
                        <app-documents v-if="settingTab == 'documents'"></app-documents>
                        <app-notifications v-if="settingTab == 'Notifications'"></app-notifications>
                        <app-security v-if="settingTab == 'Security'"></app-security>
                        <app-activity v-if="settingTab == 'Activity'"></app-activity>
                        <app-bank v-if="settingTab == 'bankinfo'"></app-bank>
                        <app-confirmeddevices v-if="settingTab == 'Confirmed'"></app-confirmeddevices>
                        <app-privacy v-if="settingTab == 'Privacy'"></app-privacy>

                        <div v-if="settingTab == 'API'">
                            <div v-if="parseInt(get_user.lead_type) == 1 &&  parseInt(get_user.verified_status) == 1">
                                <developer-option ></developer-option>
                            </div>
                            <p v-else>
                                Get your business account verified to view the API key details. If you have any questions or need assistance, please reach out to <a href="mailto:support@capitalwallet.com" class="themecolor">support@capitalwallet.com</a>
                            </p>
                        </div>
                        
                        <!-- <app-api v-if="settingTab == 'API'"></app-api> -->
                        <app-accountlimits v-if="settingTab == 'Limits'"></app-accountlimits>
                        <app-cryptoaddresses v-if="settingTab == 'Crypto'"></app-cryptoaddresses>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import appaccount from "./files/account";
import appnotifications from "./files/notifications";
import organization from "./files/organization_info";
import addressinfo from "./files/address_info";
import documents from "./files/documents";
import appsecurity from "./files/security";
import appactivity from "./files/activity";
import appbank from "./files/bank";
import appconfirmeddevices from "./files/confirmed-devices";
import appprivacy from "./files/privacy";
import appapi from "./files/api";

import developerOption from "../api-access/api-access";
import accountlimits from "./files/account_limits";
import cryptoaddresses from "./files/crypto_addresses";
// import tradingMixins from '@/plugins/trading';
import commonAllMixins from "@/plugins/commonAll";
export default {
    name: "Settings",
    mixins: [commonAllMixins],
    data() {
        return {
            settingTab: "Account",
            pageLoader: false,
        };
    },
    components: {
        appAccount: appaccount,
        appNotifications: appnotifications,
        appSecurity: appsecurity,
        appActivity: appactivity,
        appBank: appbank,
        appConfirmeddevices: appconfirmeddevices,
        appPrivacy: appprivacy,
        appApi: appapi,
        appAccountlimits: accountlimits,
        appCryptoaddresses: cryptoaddresses,
        appOrganization: organization,
        appAddressinfo: addressinfo,
        appDocuments: documents,
        developerOption
    },
    created(){
        if(this.$route.query.settingTab){
            this.settingTab = this.$route.query.settingTab
        }
        this.pageName("Settings");
    }
};
</script>



// WEBPACK FOOTER //
// src/components/website/settings/settings.vue